import React, {useEffect, useState} from "react";
import "./HomeworkStudentPage.sass";
import StudentGrid from "../../../_components/student/StudentGrid";
import {useDispatch, useSelector} from "react-redux";
import HomeworkTable from "../../../_components/student/homeworkTable/HomeworkTable";
import {IDLE, LOADING} from "../../../common/statuses";
import Spinner from "../../common/anonymous/Spinner";
import {getAllStudentHomework} from "../../../_actions/student/hw/hwService";
import {clearHWState} from "../../../_actions/student/hw/hwReducer";
import EmptyCourseBlock from "../../../_containers/infoblock/EmptyCourseBlock";
import {clearGameState} from "../../../_actions/game/gameReduce";
import {ADDRESS} from "../../../_api/client";

export default function HomeworkStudentPage() {

    const [svgList, setSvgList] = useState({});

    const {courses} = useSelector(state => state.auth.current)
    const {mental, status} = useSelector(state => state.hw.courses)

    const dispatch = useDispatch();

    useEffect(() => {
        if (status === IDLE) {
            dispatch(getAllStudentHomework());
        }
    }, [status, dispatch])
    useEffect(() => {
        if (courses) {
            courses.forEach(c => {
                if (c.avatar) {
                    fetch(`${ADDRESS}/avatar/svg/${c.avatar}`)
                        .then(res => res.text())
                        .then((payload) => {
                            const res = {...svgList};
                            res[c.avatar] = payload;

                            setSvgList(res);
                        })
                }
            })
        }
    }, [courses])
    useEffect(() => {
        document.title = 'КьюАй - Домашнее задание'
        dispatch(clearGameState())
        return () => dispatch(clearHWState())
    }, [])

    if (status === IDLE || status === LOADING) {
        return <Spinner/>
    }

    const renderMentalHW = () => {
        const course = courses.find(course => course.name === "Ментальная арифметика");
        if (course) {
            return <>
                <div className="HomeworkStudentPage-tab-wrapper">
                    {course.avatar && <div className="HomeworkStudentPage-tab-icon"
                                           dangerouslySetInnerHTML={{__html: svgList[course.avatar]}}></div>}
                    <div className="HomeworkStudentPage-tab-label">Ментальная арифметика</div>
                </div>
                <HomeworkTable data={mental}/>
            </>
        } else {
            return <EmptyCourseBlock text="Для тебя нет домашнего задания"/>
        }
    }

    return (
        <div className="HomeworkStudentPage-wrapper">
            <StudentGrid/>
            <div className="HomeworkStudentPage-hw-wrapper">
                {renderMentalHW()}
            </div>

        </div>
    )
}